import * as validate from 'validate.js';
import axios from 'axios';

export default class BaseForm {
  constructor(id) {
    const element = document.getElementById(id);
    if (element) {
      this.init();
    }
  }

  init(formId) {
    this.form = document.getElementById(formId);
    this.loader = document.getElementById('loader');
    this.submitBtn = document.getElementById('submit-btn');
    this.formInvalid = document.getElementById('form-invalid');

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.validateForm(this.getFormData());
      return false;
    });

    // this.form.querySelectorAll('.field-input[required], .field-message[required]').forEach((el) => {
    //   el.addEventListener('blur', () => {
    //     const errors = validate.single(el.value, { presence: { allowEmpty: false } });
    //     this.displayError(errors, el.name);
    //   });
    // });
    // Array.from(this.form.getElementsByClassName('field-email')).forEach((el) => {
    //   el.addEventListener('blur', () => {
    //     const errors = validate.single(el.value, { email: true, presence: { allowEmpty: false } });
    //     this.displayError(errors, el.name);
    //   });
    // });
  }

  getFormData() {
    return Object.fromEntries(new FormData(this.form).entries());
  }

  submit() {
    document.getElementById('error-message')?.classList.add('hidden');
    this.showLoader();
    this.form.classList.add('pointer-events-none', 'opacity-35');

    const formData = new FormData(this.form);

    axios.post('/' + this.form.action.value, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        if (response.data.success || response.data.message === 'Entry saved.') {
          document.getElementById('success-message').classList.remove('hidden');
          this.form.classList.add('hidden');
          this.hideLoader();
        } else {
          this.form.classList.remove('pointer-events-none', 'opacity-35');
          this.hideLoader();
          document.getElementById('error-message').classList.remove('hidden');
        }
      }, (response) => {
        this.hideLoader();
        document.getElementById('error-message').classList.remove('hidden');
      });
  }

  validateForm(data) {
    console.log('validate');
    this.clearErrors();
    validate.async(data, this.getFormValidationConstraints(), { format: 'detailed' })
      .then(() => {
        this.submit();
      }, (errors) => {
        this.displayErrors(errors);
      });
  }

  // displayError(errors, elementyName) {
  //   if (errors) {
  //     this.addErrorToElement(elementyName);
  //   } else {
  //     this.removeErrorToElement(elementyName);
  //   }
  // }

  displayErrors(errors) {
    errors.forEach(error => {
      this.addErrorToElement(error.attribute);
    });
    if (this.formInvalid) {
      // this.formInvalid.classList.remove('hidden');
      setTimeout(() => {
        this.formInvalid.classList.remove('hidden');
      }, 500);
    }
  }

  addErrorToElement(name) {
    const el = this.form.querySelector('[name="' + name + '"]').closest('.field-group');
    const inputEl = el.querySelector('input, textarea, .choices');
    const errorMsg = el.querySelector('.error-message');
    if (el) {
      el.classList.add('has-error');
      inputEl?.setAttribute('aria-invalid', true);
      errorMsg.innerText = errorMsg.dataset.message;
    }
  }

  removeErrorToElement(name) {
    const el = this.form.querySelector('[name="' + name + '"]').closest('.field-group');
    const inputEl = el.querySelector('input');
    const errorMsg = el.querySelector('.error-message');
    if (el) {
      el.classList.remove('has-error');
      inputEl?.removeAttribute('aria-invalid');
      errorMsg.innerText = '';
    }
  }

  clearErrors() {
    Array.from(this.form.getElementsByClassName('has-error')).forEach((el) => {
      const inputEl = el.querySelector('input');
      const errorMsg = el.querySelector('.error-message');
      el.classList.remove('has-error');
      inputEl?.removeAttribute('aria-invalid');
      errorMsg.innerText = '';
    });
    if (this.formInvalid) {
      console.log('true');
      this.formInvalid.classList.add('hidden');
    }
  }

  showLoader() {
    if (this.loader) {
      this.loader.classList.remove('hidden');
    }
    this.submitBtn.setAttribute('disabled', 'disabled');
  }

  hideLoader() {
    if (this.loader) {
      this.loader.classList.add('hidden');
    }
    this.submitBtn.removeAttribute('disabled');
  }

  notEmptyConstraint(field) {
    const obj = {};
    obj[field] = {
      presence: {
        allowEmpty: false
      }
    };
    return obj;
  }

  emailConstraint(formEmail = 'formEmail') {
    const obj = {};
    obj[formEmail] = {
      presence: {
        allowEmpty: false
      },
      email: true
    };
    return obj;
  }
}
